import axiosInstance from "./axiosInstance";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import APIErrorHandler from "./errorHandler";

/**
 * Bridge X Global API Response Structure
 */
export interface BridgeXResponse<T = any> {
  success: boolean;
  data: {
    rows: T[];
    count: number;
  };
  error: any;
}

/**
 * API Response Type (what services return)
 */
export interface APIResponse<T = any> {
  rows: T[];
  count: number;
}

class APIService {
  async get<T>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<APIResponse<T>> {
    const response: AxiosResponse<BridgeXResponse<T>> = await axiosInstance.get(
      url,
      config,
    );
    return response.data.data;
  }

  async post<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<APIResponse<T>> {
    const response: AxiosResponse<BridgeXResponse<T>> =
      await axiosInstance.post(url, data, config);
    return response.data.data;
  }

  async put<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<APIResponse<T>> {
    const response: AxiosResponse<BridgeXResponse<T>> = await axiosInstance.put(
      url,
      data,
      config,
    );
    return response.data.data;
  }

  async patch<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<APIResponse<T>> {
    const response: AxiosResponse<BridgeXResponse<T>> =
      await axiosInstance.patch(url, data, config);
    return response.data.data;
  }

  async delete<T>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<APIResponse<T>> {
    const response: AxiosResponse<BridgeXResponse<T>> =
      await axiosInstance.delete(url, config);
    return response.data.data;
  }

  async upload<T>(
    url: string,
    formData: FormData,
    onUploadProgress?: (e: any) => void,
  ): Promise<APIResponse<T>> {
    const response: AxiosResponse<BridgeXResponse<T>> =
      await axiosInstance.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
      });
    return response.data.data;
  }
}

const apiService = new APIService();
export default apiService;
